module.exports = __webpack_public_path__ + "a606c663f657e5c0ab98a0fc645ed433.svg";